import isServerSide from '@helpers/misc/isServerSide'
import MobileOrDesktopContext from '@providers/MobileOrDesktopContext'
import {useContext} from 'react'
import {useState, useEffect} from 'react'

export default function useHeight() {
  const ssrMobileOrDesktop = useContext(MobileOrDesktopContext)
  const ssrHeight = ssrMobileOrDesktop === 'mobile' ? 800 : 1080

  const [height, setHeight] = useState(isServerSide() ? ssrHeight : window.innerHeight)

  useEffect(() => {
    const handler = function () {
      setHeight(window.innerHeight)
    }

    window.addEventListener('resize', handler)
    return () => {
      window.removeEventListener('resize', handler)
    }
  }, [])

  return height ?? ssrHeight
}
